import React from 'react';
import './QualityCheck.css'
import { FaHandPointRight } from "react-icons/fa6";

const QualityCheck = () => {
    return (
        <div className='qualityContainer'>
            <div className='qualityChild' > <FaHandPointRight className='righthandquality' />
                <p>বাছাইকৃত কাঁচামাল</p>
            </div>
            <div className='qualityChild'> <FaHandPointRight className='righthandquality' />
                <p>পরিষ্কার ও শুকানোর বিশেষ ব্যবস্থা</p>
            </div>
            <div className='qualityChild'> <FaHandPointRight className='righthandquality' />
                <p>আলাদা গ্রাইন্ডিং ইউনিট</p>
            </div>
            <div className='qualityChild'> <FaHandPointRight className='righthandquality' />
                <p>স্বাস্থ্যসম্মত প্যাকেজিং</p>
            </div>
            <div className='qualityChild'> <FaHandPointRight className='righthandquality' />
                <p>নিয়মিত মান পরীক্ষা</p>
            </div>
        </div>
    );
};

export default QualityCheck;